const addressListTemplate = [
    {
        title: 'General',
        type: 'columns',
        fields: [
            {
                key: 'select',
                sortable: false,
                width: '50px'
            },
            {
                key: 'name',
                title: 'Name',
                sortable: true
            },
            {
                key: 'lastname',
                title: 'Last Name',
                sortable: true
            },
            {
                key: 'adrdefault.docid',
                title: 'Document ID',
                sortable: true
            },
            {
                key: 'adrdefault.address',
                title: 'Address',
                sortable: true
            },
            {
                key: 'adrdefault.city.name',
                title: 'City',
                sortable: true
            },
            {
                key: 'adrdefault.city.state.name',
                title: 'State',
                sortable: true
            },
            {
                key: 'adrdefault.city.state.country.name',
                title: 'Country',
                sortable: true
            },
            {
                key: 'adrdefault.zip',
                title: 'Zip',
                sortable: true
            }
        ]
    }
];

export { addressListTemplate };
